import {SerializedStyles} from '@emotion/react';
import {css, useTheme} from '@mui/material';
import {SvgIconProps} from '@mui/material/SvgIcon';
import {isObject} from 'lodash';
import React from 'react';
import {useIntl} from 'react-intl';
import {GetStylesFunction} from 'src/js/common/types';
import TranslateUtils from 'src/js/common/utils/translate_utils';

import {DlMuiDynamicIcon} from './DlMuiDynamicIcon';

interface OwnProps extends SvgIconProps {
  inputCss?: SerializedStyles;
  onClick?: () => void;
  disabled?: boolean;
  areFiltersOpen?: boolean;
  title: string;
  iconName?: string;
  useFixedViewBox?: string | number | boolean;
}

type Props = OwnProps;

/** @deprecated use LightIconButton instead */
export const DlMuiToggleFilters: React.FC<Props> = (props) => {
  const {inputCss, disabled = false, onClick, areFiltersOpen, title, iconName = 'filterIcon', useFixedViewBox, ...extraProps} = props;
  const intl = useIntl();
  const theme = useTheme();
  const styles = getStyles({
    theme,
    params: {inputCss, disabled, areFiltersOpen},
  });

  const translatedTitle = intl && TranslateUtils.translate(title, intl);

  const handleClick = (eventObject: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    if (!disabled && onClick) {
      if (isObject(eventObject)) {
        onClick();
      }
    }
  };

  return (
    <DlMuiDynamicIcon
      {...extraProps}
      data-name={'dl-mui-toggle-filters--icon-button'}
      data-open={Boolean(areFiltersOpen)}
      onClick={handleClick}
      tabIndex={disabled ? -1 : 0}
      disabled={disabled}
      inputCss={styles.iconWrapper}
      iconTitle={translatedTitle}
      iconName={iconName}
      svgIconInputCss={styles.icon}
      useFixedViewBox={useFixedViewBox}
    />
  );
};

DlMuiToggleFilters.displayName = 'DlMuiToggleFilters';

const getStyles: GetStylesFunction = (options) => {
  return {
    iconWrapper: css`
      width: 32px;
      height: 32px;
      border-radius: 8px;
      cursor: pointer;
      border: 1px solid var(--dlThemeGray-300);
      background: var(--background) !important;
      color: var(--fill) !important;
      --background: var(--dlToggleFiltersBackround);
      --fill: var(--dlToggleFilters);

      &[data-open='true'] {
        --background: var(--dlToggleFiltersOpenBackround);
        --fill: var(--dlToggleFiltersOpen);
      }
      &:hover,
      &:active {
        border: none;
        --background: var(--dlToggleFiltersHoverBackground);
        --fill: var(--dlToggleFiltersHover);
        --dlMultiColorPrimary: var(--dlToggleFiltersHover);
      }
    `,
    icon: css`
      width: 20px;
      height: 16px;
      cursor: pointer;
      ${options?.params?.inputCss ?? ''};
    `,
  };
};
